<div class="p-2">
    <div class="w-100">
        <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"></ppl-billing-filter>
    </div>
    <div>
        @if(ignoredTimesheetData.length > 0) {
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false" [data]="ignoredTimesheetData"
            [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [rowsToDisplay]="20"
            [loadPage]="true" [enableActions]="false" (onPageLoad)="onPageLoad($event)" [customDataLoaded]="true" [tableScrollable]="true">
        </ppl-list-table>
    } @else {
        <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
            find the records</div>
        }
    </div>
</div>